const container = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  alignContent: "stretch",
  alignItems: "flex-start"
}
const item = {
  display: "inline-block",
  order: 0,
  flex: "0 1 auto",
  alignSelf: "auto",
  width: 330, 
  margin: 10, 
  padding: 3, 
}
const errorItem = Object.assign({}, item, { border: "1px solid red" })
const correctItem = Object.assign({}, item, { border: "1px solid cyan" })

const styles = {
  container,
  item,
  correctItem, 
  errorItem, 
}

export default styles